// extracted by mini-css-extract-plugin
export default {"labelWrapper":"DummySettingsAutoSelect_labelWrapper__2FTRP","item":"DummySettingsAutoSelect_item__XbpXL","tooltip":"DummySettingsAutoSelect_tooltip__jbHA9"};